import React from 'react';
import CountUp from './CountUp';

/**
 * <StatCard /> — Overview + Equipment stat tile.
 * @param {string} icon      Font Awesome class
 * @param {ReactNode} value  big number
 * @param {string} label     caption
 * @param {string} [delta]   small right-aligned delta text
 * @param {boolean} [up=true]  delta tone: success (true) / danger (false)
 * @param {'success'|'danger'|'neutral'} [deltaTone]  explicit delta tone (wins over `up`) —
 *        use 'neutral' for counts that aren't good or bad ("3 awaiting approval")
 * @param {string} [color]   icon-well foreground (defaults to brand blue)
 * @param {string} [bg]      icon-well background
 * @param {boolean} [bigValueColor]  colour the value with `color` (Equipment style)
 * @param {boolean} [loading]  skeleton value while data loads — never show a fake 0
 */
const DELTA = { success: 'var(--cw-success-fg)', danger: 'var(--cw-danger-fg)', neutral: 'var(--cw-text-muted)' };

const StatCard = ({
  icon, value, label, delta, up = true, deltaTone, color = 'var(--cs-blue, #1A80E5)', bg = 'var(--cs-blue-light, #EBF4FF)',
  bigValueColor = false, loading = false,
}) => (
  <div className="cw-stat" aria-busy={loading || undefined}>
    <div className="cw-stat-top">
      <div className="cw-well" style={{ background: bg, color }} aria-hidden="true">
        <i className={icon} />
      </div>
      {delta != null && delta !== '' && !loading && (
        <span className="cw-stat-delta" style={{ color: DELTA[deltaTone || (up ? 'success' : 'danger')] }}>{delta}</span>
      )}
    </div>
    <div className="cw-stat-value" style={bigValueColor ? { color } : undefined}>
      {loading ? <span className="cw-skel" style={{ display: 'inline-block', width: 56, height: 24 }} /> : <CountUp value={value} />}
    </div>
    <div className="cw-stat-label">{label}</div>
  </div>
);

export default StatCard;
